import { useCallback } from 'react'
import { debounce } from 'lodash'
import { useAppDispatch } from '@/state'

import {
  PlayerCardActions,
  PlayerCardModels,
  PlayerCardThunks,
} from '@/state/player-card'

export const usePlayerCardActions = () => {
  const dispatch = useAppDispatch()

  const getCountriesList = useCallback(() => {
    dispatch(PlayerCardThunks.getCountriesListThunk())
  }, [dispatch])

  const getPlayerInfo = useCallback(
    (playerId: string) => {
      dispatch(PlayerCardThunks.getPlayerThunk(playerId))
    },
    [dispatch],
  )

  // eslint-disable-next-line
  const getPlayerRealBalance = useCallback(
    debounce((playerId: string) => {
      dispatch(PlayerCardThunks.getPlayerBalanceThunk({ playerId }))
    }, 500),
    [dispatch],
  )

  // eslint-disable-next-line
  const getRGExclusion = useCallback(
    debounce((payload: PlayerCardModels.GetRGExclusionPayload) => {
      dispatch(PlayerCardThunks.getRGExclusionThunk(payload))
    }, 500),
    [dispatch],
  )

  const addRGExclusion = useCallback(
    (payload: PlayerCardModels.AddRGExclusionPayload) => {
      dispatch(PlayerCardThunks.addRGExclusionThunk(payload))
    },
    [dispatch],
  )

  const setRGExclusionFilters = useCallback(
    (payload: PlayerCardModels.ResponsibleGamingFiltersType) => {
      dispatch(PlayerCardActions.setRGExclusionFiltersAction(payload))
    },
    [dispatch],
  )

  const setRGCoolOffFilters = useCallback(
    (payload: PlayerCardModels.ResponsibleGamingFiltersType) => {
      dispatch(PlayerCardActions.setRGCoolOffFiltersAction(payload))
    },
    [dispatch],
  )

  const resetPlayerCardInfo = () => {
    PlayerCardActions.resetPlayerCardAction()
  }

  const updatePlayerCardInfo = useCallback(
    (payload: PlayerCardModels.UpdatePlayerPayload) => {
      dispatch(PlayerCardThunks.updatePlayerDataThunk(payload))
    },
    [dispatch],
  )

  const updateAccountStatus = useCallback(
    (payload: PlayerCardModels.UpdateAccountStatusPayload) => {
      dispatch(PlayerCardThunks.updateAccountStatusThunk(payload))
    },
    [dispatch],
  )

  const updateKYCStatus = useCallback(
    (payload: PlayerCardModels.UpdateKYCStatusPayload) => {
      dispatch(PlayerCardThunks.updateKYCStatusThunk(payload))
    },
    [dispatch],
  )

  const setPlayerBalance = useCallback(
    (payload: PlayerCardModels.SetPlayerBalancePayload) => {
      dispatch(PlayerCardThunks.setPlayerBalanceThunk(payload))
    },
    [dispatch],
  )

  return {
    addRGExclusion,
    getCountriesList,
    getPlayerInfo,
    getPlayerRealBalance,
    getRGExclusion,
    resetPlayerCardInfo,
    updatePlayerCardInfo,
    updateAccountStatus,
    updateKYCStatus,
    setPlayerBalance,
    setRGCoolOffFilters,
    setRGExclusionFilters,
  }
}
